import styled from "styled-components";
import ButtonLink from "@/components/inputs/buttonLink";
import themes from "@/styles/themes";
interface ISimpleTextProps {
  color?: string
  linkColor?: string
}

const SimpleText = styled.p<ISimpleTextProps>`
  font-size: 13px !important;
  color: ${props => props.color || themes.grey};
  font-weight: normal;
  margin: 15px 0;
  line-height: 1.38;

  a {
    color: ${props => props.linkColor || props.color || themes.grey};
    font-weight: 700;
  }

  b {
    font-weight: 700;
  }

  span {
    font-size: 16px;
    margin: 10px 0;
    font-weight: 700;
  }

  ${ButtonLink} {
    font-size: 12px;
  }
`
export const TextHelper = styled.span `
  margin-top: 2px;
  font-weight: 400 !important;
  display: inline-block;
  font-size: 13px !important; 
`
export const BlueLink = styled.a`
  font-weight: 700; 
  color: ${themes.estadao} !important; 
`

export default SimpleText